import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import AttributeDef from 'models/configuration/attribute_def';
import CustomAttributeBase from './custom_attribute_base';
import ExternalLink from 'components/lib/external_link';
import { formatValue } from './visible_custom_attribute';
import { isUrlValid } from 'scripts/presentation/components/lib/linkify_it';

const MUSTACHE_REGEX = /{{([\s\S]+?)}}/g;

export const VisibleCustomAttributeValue = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function VisibleStringCustomAttribute({ className, def, value, location }) {
  if (!value) {
    return null;
  }

  const displayVal = formatValue(value, def.type);
  const renderVal = getRenderVal(def, value, displayVal, location);
  const classNames = classnames('visibleCustomAttribute', className);

  return (
    <CustomAttributeBase className={classNames} label={def.label}>
      <VisibleCustomAttributeValue title={displayVal}>{renderVal}</VisibleCustomAttributeValue>
    </CustomAttributeBase>
  );
}

function getRenderVal(def, value, displayVal, location) {
  if (def.linkTemplate && !isUrlValid(displayVal)) {
    let url = _.template(def.linkTemplate, {
      interpolate: MUSTACHE_REGEX,
      escape: MUSTACHE_REGEX,
    })({ value });

    return (
      <ExternalLink
        url={url}
        text={displayVal}
        className="transactionGroup-externalLink"
        subType={_.get(location, 'subType')}
        type={_.get(location, 'type')}
        attrName={def.attr}
      />
    );
  } else if (isUrlValid(displayVal)) {
    return (
      <ExternalLink
        url={displayVal}
        text={displayVal.replace(/https?:\/\/www\.|^https?:\/\/|www\./, '')}
        className="transactionGroup-externalLink"
        subType={_.get(location, 'subType')}
        type={_.get(location, 'type')}
        attrName={def.attr}
      />
    );
  }

  return displayVal;
}

VisibleStringCustomAttribute.propTypes = {
  className: PropTypes.string,
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  value: PropTypes.any,
  location: PropTypes.shape({
    type: PropTypes.string,
    subType: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/visible_string_custom_attribute.jsx